class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: 'header',
			openMenu: '#open-menu',
			closeMenu: '#close-menu',
			openSubMenu: '[data-mobile-header="open-submenu"]',
			closeSubMenu: '[data-mobile-header="close-submenu"]',
			mainMenu: '[data-mobile-header="scope"]',
			subMenu: '[data-mobile-menu="submenu"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.openMenu, this.openMainMenu.bind(this));
		this.$scope.on('click', this.config.closeMenu, this.closeMainMenu.bind(this));
		this.$scope.on('click', this.config.openSubMenu, this.openSubMenu.bind(this));
		this.$scope.on('click', this.config.closeSubMenu, this.closeSubMenu.bind(this));
	}

	openMainMenu(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		$scope.find(this.config.mainMenu).addClass('open');
	}

	closeMainMenu(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		$scope.find(this.config.mainMenu).removeClass('open');
	}

	openSubMenu(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let $menu = $scope.find($button.data('target'));
		$menu.addClass('open');
	}

	closeSubMenu(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $menu = $button.closest(this.config.subMenu);
		$menu.removeClass('open');
	}
}

export default new Header;